import {
    DeleteBody,
    DeleteCTA,
    DeleteTitle,
    GenerateBody,
    GenerateCTA,
    GenerateTitle,
    UpdateToDraftBody,
    UpdateToDraftCTA,
    UpdateToDraftTitle,
    UpdateToPublishedBody,
    UpdateToPublishedCTA,
    UpdateToPublishedTitle,
} from "./messages.generated";

export enum HostedLensDisclaimerEnum {
    GENERATE = "generate",
    UPDATE_TO_DRAFT = "update-to-draft",
    UPDATE_TO_PUBLISHED = "update-to-published",
    DELETE = "delete",
}

export const hostedLensDisclaimerOptions = {
    [HostedLensDisclaimerEnum.GENERATE]: {
        title: <GenerateTitle />,
        body: <GenerateBody />,
        cta: <GenerateCTA />,
    },
    [HostedLensDisclaimerEnum.UPDATE_TO_DRAFT]: {
        title: <UpdateToDraftTitle />,
        body: <UpdateToDraftBody />,
        cta: <UpdateToDraftCTA />,
    },
    [HostedLensDisclaimerEnum.UPDATE_TO_PUBLISHED]: {
        title: <UpdateToPublishedTitle />,
        body: <UpdateToPublishedBody />,
        cta: <UpdateToPublishedCTA />,
    },
    [HostedLensDisclaimerEnum.DELETE]: {
        title: <DeleteTitle />,
        body: <DeleteBody />,
        cta: <DeleteCTA />,
    },
};

export type HostedLensDisclaimerOptions = keyof typeof hostedLensDisclaimerOptions;
